export default "__VITE_ASSET__C02lhF1Y__"